export default "__VITE_ASSET__DUHIwGrp__"